<template>
  <v-container grid-list-xl>
    <v-flex xs9>
      <view-title :showBreadCrum="false" />
    </v-flex>
    <DisabledBanner />
  </v-container>
</template>
<script>
import DisabledBanner from '../../components/disabledBanner.vue';

export default {
  name: 'UsersListing',
  components: {
    DisabledBanner,
  },
  async mounted() {
    this.$store.commit('adminPanel/setViewTitle', {
      depth: 0,
      title: 'Users',
      to: { name: 'users-listing' },
    });
  },
};
</script>
